// general imports
import { Injectable } from '@angular/core';
import { endpoints, notificationMessage } from './../common/utils/configUrl';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material';

// imports VO
import { ResponseVO } from '../common/vo/responseVO';
import { RequestVO } from '../common/vo/requestVO';
import { CatalogoVO } from '../common/vo/catalogoVO';
import { CatalogoResponseVO } from '../common/vo/catalogoResponseVO';
import { ErrorVO } from '../common/vo/errorVO';

// services
import { DataService } from './data.service';

// componentes
import { ConfirmationDialogComponent } from '../shared/confirmation-dialog/confirmation-dialog.component';
import { LifeTimeSesionService } from './life-time-session.service';

/**
 * Service created by: irvin uriel
 */

//  @Injectable({
//    providedIn: 'root'
//  })
export class MascotaService {
  private urlCreate: string = endpoints.TipoMascotaCreate;
  private urlFindByAllFields: string = endpoints.TipoMascotaFindByAllFields;
  private urlDelete: string = endpoints.TipoMascotaDelete;
  private urlUpdate: string = endpoints.TipoMascotaUpdate;
  constructor(private _http: HttpClient,
              private _life: LifeTimeSesionService,
              private _dataService: DataService,
              public _dialog: MatDialog) { }

  /**
   * Creación de un tipo mascota
   * @param form : contenido para el campo de parameters
   */
  tipoMascotaCreate(form: CatalogoVO): Observable<ResponseVO<CatalogoResponseVO>> {
    // validar si se refresca el token o continua con el token actual
    this._life.resetToken();

    // crea httpOptions
    let httpOp =  {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this._dataService.getToken() })
    }
    // genera requestVO
    let requestVO = new RequestVO<CatalogoVO>();
    requestVO.parameters = form;
    return this._http
      .post<ResponseVO<CatalogoResponseVO>>(this.urlCreate, requestVO, httpOp)
      .pipe(catchError(this._dataService.handleError));
  }

  /**
   * Creación de un tipo mascota
   * @param form : contenido para el campo de parameters
   */
  tipoMascotaUpdate(form: CatalogoVO): Observable<ResponseVO<CatalogoResponseVO>> {
    // validar si se refresca el token o continua con el token actual
    this._life.resetToken();

    // crea httpOptions
    let httpOp =  {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this._dataService.getToken() })
    }
    // genera requestVO
    let requestVO = new RequestVO<CatalogoVO>();
    requestVO.parameters = form;
    return this._http
      .put<ResponseVO<CatalogoResponseVO>>(this.urlUpdate, requestVO, httpOp)
      .pipe(catchError(this._dataService.handleError));
  }
  
  /**
   * Eliminacion de un tipo mascota
   * @param id : id de un dato de tipo mascota
   */
  tipoMascotaDelete(id: number): Observable<ResponseVO<any>> {
    // validar si se refresca el token o continua con el token actual
    this._life.resetToken();

    // crea httpOptions
    let httpOp =  {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this._dataService.getToken() })
    }
    return this._http
      .delete<ResponseVO<any>>(`${this.urlDelete}/${id}`, httpOp)
      .pipe(catchError(this._dataService.handleError));
  }

  /**
   * Busqueda por criterios de un tipo mascota
   * @param form : contenido para el campo de parameters
   */
  tipoMascotaFindByAllFields(parameters: CatalogoVO, page: number, size: number): Observable<ResponseVO<CatalogoResponseVO[]>> {
    // validar si se refresca el token o continua con el token actual
    this._life.resetToken();

    // crea httpOptions
    let httpOp =  {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this._dataService.getToken() })
    }
    // genera requestVO
    let requestVO = new RequestVO<CatalogoVO>();
    requestVO.parameters = parameters;
    requestVO.page = page;
    requestVO.size = size;
    return this._http
      .post<ResponseVO<CatalogoResponseVO[]>>(this.urlFindByAllFields, requestVO, httpOp)
      .pipe(catchError(this._dataService.handleError));
  }

  /**
   * Funcion para confirmar la eliminacion del registro.
   * Invoca un Matdialog para realizar la confirmacion de eliminación.
   */
  eliminarMascota(infoRow: CatalogoResponseVO): void {

    let dialogRef = this._dialog.open(ConfirmationDialogComponent, {
      data: infoRow,
      disableClose: true
    });
    // Espera el cierre de la Modal, lo cual indicará que se aprobo la eliminacion.
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._dataService.startLoading();
        // Se lanza el servicio delete Mascota
        this.tipoMascotaDelete(result.id).subscribe(
          (response) => {
            // Se valida que la transaccion se haya realizado con exito y se notifica,
            // de lo contrario se muestran los errores.
            if (response.success) {
              this._dataService.setFetchData(true);
              this._dataService.setSuccessNotificationMessage(`${infoRow.idNombre} ${notificationMessage.DELETE}`);
            } else {
              this._dataService.addErrors(response.errors);
            }
            this._dataService.stopLoading();
          },
          (error: ErrorVO[]) => {
            this._dataService.stopLoading();
            this._dataService.addErrors(error);
          });
      }
    });

  }
}
